module.exports = __webpack_public_path__ + "assets/img/kakaclo-store.a3e347ce.png";